export class LoadClm {
  static readonly type = '[ClmValue] LoadClm';
}
export class ClearClm {
  static readonly type = '[ClmValue] ClearClm';
}
